export default __webpack_public_path__ + "static/media/logo-icon-light.9426a286.svg";